import type { AssessmentComponent, AssessmentResult, AssessmentsData } from "@pandas/http-client";

const assessmentOrder: (keyof AssessmentsData)[] = [
	"grader-front-cosmetics",
	"grader-back-cosmetics",
	"grader-body-frame-cosmetics",
	"grader-camera-cosmetics",
	"grader-lcd-condition",
	"grader-device-skin",
	"self-overall-condition",
	"self-charger",
	"self-device-material",
	"self-strap",
];

export const getFilteredAssessments = (supportedAssessments: AssessmentsData) => {
	const filteredAssessments = Object.keys(supportedAssessments);
	return filteredAssessments;
};

export const getSortedAssessmentKeys = (supportedAssessments: AssessmentsData) => {
	const filteredAssessments = getFilteredAssessments(supportedAssessments);

	const sortedAssessmentKeys = filteredAssessments.sort(
		(a, b) => assessmentOrder.indexOf(a) - assessmentOrder.indexOf(b),
	);

	return sortedAssessmentKeys;
};

const conditionOrder = (component: string) => {
	switch (component) {
		case "Battery Class":
			return ["A", "B", "C"];
		case "Strap":
		case "Charger":
			return ["Yes", "No"];
		case "Device Material":
			return ["Titanium", "Stainless", "Aluminum"];
		default:
			return ["A", "B", "C", "D", "Like New", "Good", "Scratches", "Poor", "Cracks", "Faulty", "No", "Yes"];
	}
};

export const getSortedConditions = (component: AssessmentComponent) => {
	const sortedConditionsKeys = Object.keys(component.conditions).sort(
		(a, b) => conditionOrder(component.name).indexOf(a) - conditionOrder(component.name).indexOf(b),
	);
	return sortedConditionsKeys;
};

export const getConditionClass = (component: AssessmentComponent, condition: string) => {
	if (component.name === "Device Material") {
		return "bg-excellent";
	}
	const sortedConditionsKeys = getSortedConditions(component);
	const conditionIndex = sortedConditionsKeys.indexOf(condition);

	if (conditionIndex === 0) {
		return "bg-excellent";
	} else if (conditionIndex === sortedConditionsKeys.length - 1) {
		return "bg-faulty";
	} else if (conditionIndex === 1) {
		return "bg-veryGood";
	} else {
		return "bg-good";
	}
};

export const getAssessmentCategory = (assessment: Pick<AssessmentResult, "component_type">) => {
	if (assessment.component_type === "functional" || assessment.component_type === "cosmetic") {
		return assessment.component_type;
	}
	return null;
};

export const getAssessmentStorageKey = (assessment: Pick<AssessmentResult, "component" | "component_type">) => {
	const category = getAssessmentCategory(assessment) ?? "unknown";
	return `${category}:${assessment.component}`;
};
